
export const info = [
  {
    id: 1,
    name: "Dirección",
    details: 
      "Defensa 2264 - La Comercial - Montevideo",

    icon: "../assets/locationIcon.png",
    
  },
  {
    id: 2,
    name: "Horarios",
    details:
      "Lunes a Viernes 24 hs. Atendemos emergencias",
  
    icon: "../assets/clockIcon.png",
    
 },

  {
    id: 3,
    name: "Contacto",
    details: "Teléfono: 098 173 504",
    icon: "../assets/phoneIcon.png",
  }
];
